import logo from '../assets/atad-logo-vertical.png';

interface LoadingOverlayProps {
  message?: string;
}

export default function LoadingOverlay({ message }: LoadingOverlayProps) {
  return (
    <div className="fixed z-50 inset-0 bg-white h-full w-full flex flex-col justify-center items-center">
      <img className="w-32 motion-safe:animate-pulse" src={logo} alt="logo" />
      {message && <p className="mt-10">{message}</p>}
    </div>
  );
}
